import {
  SET_DATASET,
  SET_FREQUENCY_DATASET,
  SET_NAME_OF_DATASET,
  SET_TYPE_OF_DATASET,
  SET_NAME_OF_COLUMNS,
  RESET_DATASET,
  RESET_FREQUENCY_DATASET,
  SET_CORRECT_VAR_TYPES
} from './types';

const initialState = {
  data: null,
  nameOfDataset: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DATASET:
      return { ...state, data: action.data };
    case SET_FREQUENCY_DATASET:
      return { ...state, frequencyDataSet: action.frequencyDataSet };
    case SET_NAME_OF_DATASET:
      return { ...state, nameOfDataset: action.nameOfDataset };
    case SET_NAME_OF_COLUMNS:
      return { ...state, nameOfColumns: action.nameOfColumns };
    case SET_TYPE_OF_DATASET:
      return { ...state, typeOfDataset: action.typeOfDataset };
    case SET_CORRECT_VAR_TYPES:
      return { ...state, variableTypes: action.variableTypes };
    case RESET_DATASET:
      return initialState;
    case RESET_FREQUENCY_DATASET:
      return { ...state, frequencyDataSet: null };
    default:
      return state;
  }
};
